import dynamic from "next/dynamic";
import React, { useContext, useEffect, useRef, useState } from "react";
import { AvailabilityCalendar } from "../../Components/Property/AvailabilityCalendar/web";
import { BigDataSingleProp } from "../../Components/BigData/SingleProp/web";
import { BreadCrumbs } from "shared-components/Components/SEO/BreadCrumbs/web";
import { SeoText } from "shared-components/Components/SEO/SeoText/web";
import { Card, Col, Grid, Row, Typography } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { ConfigStateContext } from "../../Contexts/Configurations/context";
import { Description } from "../../Components/Property/Description/web";
import { Facilities } from "../../Components/Property/Facilities/web";
import { Financing } from "../../Components/Financing/web";
import { Footer } from "../Footer/web";
import { Guarantee } from "shared-components/Components/Property/Guarantee/web";
//import { Header } from "../Header/web";
import { InformationRequest } from "../../Components/Property/InformationRequest/web";
import { isTemporal, ocultarBigDataFicha_aPedidoHardcodeado } from "../../Utils/Functions";
import { LoadOnScreen, OnScreen } from "../../Components/OnView/web";
import { Navigation } from "./Navigation/web";
import { OfficeHours } from "../../Components/OfficeHours/web";
import { PicHomeFooter } from "../Footer/PicHomeFooter/web";
import { PriceTag } from "../../Components/Property/PriceTag/web";
import { ProjectInfo } from "../../Components/Project/Info/web";
import { PropComponentMode } from "../../Components/Property/PropertyInterfaces";
import { PropertyAffixBottom } from "./PropertyAffixBottom/web";
import { PropertyAffixHeader } from "./PropertyAffixHeader/web";
import { PropertyCover } from "./PropertyCover/web";
import { PropertyLocalInformationMap } from "./PropertyLocalInformation/web";
import { Subsidiaries } from "../../Components/Property/Subsidiaries/web";
import { TechnicalSheet } from "../../Components/Property/TechnicalSheet/web";
import { TemporaryRental } from "../../Components/Property/TemporaryRental/web";
import { Title } from "../../Components/Property/Title/web";
import { TypologyTag } from "../../Components/Property/TypologyTag/web";
import { Units } from "../../Components/Project/Units/web";
import { useGoogleTagManager } from "../../GlobalHooks/web/GoogleTagManager.hook";
import { useMarkSeen } from "../../Components/Property/SeenStatus/SeenStatus.hook";
import { usePropertyDetailsTwo } from "./PropertyDetailsTwo.hook";
import { useRouter } from "next/router";
import { useTheme } from "../../Styles/ThemeHook";
import { WorkProgress } from "../../Components/Project/WorkProgress/web";
import "./styles.less";
import { FichaStructData } from "shared-components/Components/Property/FichaStructData";
import Head from "next/head";
import dayjs from "dayjs";
import Header from "RefactorSearchPage/Header/web";

const { Text } = Typography;
const { useBreakpoint } = Grid;

//@ts-ignore
const PropertySimilars = dynamic(
	(): any => import("./PropertySimilars/web").then(mod => mod.PropertySimilars),
	{ ssr: false }
);

//@ts-ignore
const PropertyModal = dynamic(
	(): any => import("./PropertyModal/web").then(mod => mod.PropertyModal),
	{ ssr: false }
);
//@ts-ignore
const Modal = dynamic((): any => import("antd").then(mod => mod.Modal), { ssr: false });
//@ts-ignore
const PropertySimilarsCards = dynamic(
	(): any =>
		import("./PropertySimilars/PropertySimilarsCards/web").then(
			mod => mod.PropertySimilarsCards
		),
	{ ssr: false }
);

interface PropertyDetailsProps {
	id: string;
	mode?: PropComponentMode;
}

export function PropertyDetails({ id, mode = "auto" }: PropertyDetailsProps) {
	const { listing, loading } = usePropertyDetailsTwo(id, mode);
	const financingRef = useRef(null);
	const [top, setTop] = useState(0);
	const [isModalOpen, setModalOpen] = useState(false);
	const [modalTabOpen, setModalTabOpen] = useState("photos");
	const [scrollDown, setScrollDown] = useState(false);
	const [showAffixInNotActive, setShowAffixInNotActive] = useState(false);
	const [showAffix, setShowAffix] = useState(false);
	const [showAffixBottom, setShowAffixBottom] = useState(true);
	const [queryRouter, setRouterQuery] = useState<string>("");
	const [technicalSheet, setTechnicalSheet] = useState<any[]>([]);
	const { country_code } = useContext(ConfigStateContext);

	const { theme } = useTheme();
	const router = useRouter();
	const screen = useBreakpoint();
	const GTM = useGoogleTagManager();
	const { markSeen } = useMarkSeen();

	const has_map = !!listing.latitude;
	const has_tour3d = !!listing.tour3d;
	const operationTypeId = listing.operation_type?.id;
	const propertyTypeId = listing.property_type?.id;
	const SCROLL_LIMIT_IN_LISTING_NOT_ACTIVE = -800;

	const handleScroll = () => {
		const HEADER = 84;
		const HEADER_AFFIX = 164;

		const scroll = window.pageYOffset;
		const form = document.getElementById("myForm");
		const alturaForm = form.offsetTop;

		if (scroll > alturaForm - HEADER_AFFIX) {
			form.classList.add("sticky");
			showAffix ? setTop(HEADER_AFFIX) : setTop(HEADER);
		} else {
			form.classList.remove("sticky");
			setTop(0);
		}
	};

	useEffect(() => {
		let type: ListingType = mode === "property" ? "PROPERTY" : "PROJECT";
		markSeen(id, type);

		if (country_code === "ce3") {
			const technicalSheetCeee = [...listing.technicalSheet];
			const minimunStay = listing.seasons && !!listing.seasons.length
				? `${listing.seasons[0].rental_data.minimum_stay} ${listing.seasons[0].rental_data.minimum_stay !== 1
					? "días"
					: "día"
				}`
				: null;

			technicalSheetCeee.push(
				{
					field: "guests",
					text: "Huéspedes",
					value: listing.guests ? listing.guests.toString() : null
				},
				{
					field: "seaview",
					text: "Vista al mar",
					value: listing.seaview ? "Sí" : "No"
				},
				{
					field: "minimum_stay",
					text: "Estadía mínima",
					value: minimunStay
				}
			);

			const filtered = technicalSheetCeee.filter((technical) => technical.field !== "disposition_name")

			setTechnicalSheet(filtered);
		} else {
			setTechnicalSheet(listing.technicalSheet);
		}
	}, []);

	useEffect(() => {
		if (router.query?.call === "1") setRouterQuery("call");
		if (router.query?.wpp === "1") setRouterQuery("wpp");
		if (router.query?.bell === "1") setRouterQuery("bell");
	}, [router.query]);

	useEffect(() => {
		const Ybug = window["Ybug"];
		if (isModalOpen && Ybug && !screen.lg) Ybug?.hide("launcher");

		return () => Ybug?.show("launcher");
	}, [isModalOpen]);

	useEffect(() => {
		if (listing.id) {
			GTM.Event({
				name: "offerdetail",
				data: {
					listing_id: listing.id,
					listing_pagetype: "offerdetail",
					listing_totalvalue: listing.price?.amount,
				},
			});
		}
	}, [listing]);

	useEffect(() => {
		let scrollPosition = 0;
		const onScroll = () => {
			if (document.body.getBoundingClientRect().top > scrollPosition) {
				setScrollDown(false);
			} else {
				setScrollDown(true);
			}

			scrollPosition = document.body.getBoundingClientRect().top;

			if (!listing.active) {
				if (scrollPosition > SCROLL_LIMIT_IN_LISTING_NOT_ACTIVE) {
					setShowAffixInNotActive(false);
				}
			}
		};

		window.addEventListener("scroll", onScroll, { passive: true });

		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	useEffect(() => {
		if (!listing.active) {
			if (showAffix) {
				if (
					document.body.getBoundingClientRect().top > SCROLL_LIMIT_IN_LISTING_NOT_ACTIVE
				) {
					setShowAffixInNotActive(false);
				} else {
					if (scrollDown) {
						setShowAffixInNotActive(true);
					} else {
						setShowAffixInNotActive(false);
					}
				}
			} else {
				setShowAffixInNotActive(false);
			}
		} else {
			setShowAffixInNotActive(showAffix);
		}
	}, [showAffix]);

	useEffect(() => {
		window.addEventListener("scroll", handleScroll, { passive: true });
		return () => window.removeEventListener("scroll", handleScroll);
	});

	
	let isOld = listing?.updated_at ? dayjs(listing.updated_at).isBefore( dayjs().subtract(1, 'year') ) : false

	return (<>
		{isOld && !listing.active && 
			<Head>
				<meta name='robots' content='noindex, nofollow' />
			</Head>
		}

		<div className="property-detail-container">
			<FichaStructData prop={listing} mode={mode} />

			{listing.isExternal && <Head>
				<meta name="robots" content="noindex, nofollow"/>
			</Head>}

			<Header showArrow={true} />
			<div className="property-detail">
				{/* Show Affix && Property Affix Header */}
				{showAffix && showAffixInNotActive && screen.lg && (
					<PropertyAffixHeader id={listing.id} listing={listing} mode={mode} />
				)}

				{/* Property Modal */}
				{isModalOpen && (
					<Modal
						className="pd-property-modal"
						visible={isModalOpen}
						centered
						footer={null}
						closeIcon={<CloseCircleOutlined />}
						onCancel={() => setModalOpen(false)}>
						<PropertyModal
							activeTab={modalTabOpen}
							onChangeTab={tab => setModalTabOpen(tab)}
							propId={id}
							mode={mode}
							listing={listing}
							isDisabledProperty={!listing.active}
						/>
					</Modal>
				)}

				{/* Main */}
				<div className="pd-main container pd-container pd-main-row">
					{/* Navigation */}
					{screen.lg && (
						<div className="container padding-small pd-navigation-col">
							<Navigation type="default" />
						</div>
					)}

					{/* In Active Prop Declaimer */}
					{!listing.active && (
						<>
							<div className="container is-disabled-property padding">
								<Card
									bodyStyle={{
										background: theme.colors.warningColor,
									}}>
									<Typography.Title
										style={{
											margin: 0,
											textAlign: "center",
										}}
										level={5}>
										{ "Estás viendo esta página porque la propiedad que estabas buscando no está disponible." }
									</Typography.Title>
								</Card>
							</div>

							{((listing.isProject && listing.commercial_units.length > 0) ||
								!listing.isProject) && (
									<Col span={24} className="padding">
										<div className="container similar-container">
											<LoadOnScreen listen={!loading}>
												<PropertySimilarsCards id={listing.id} mode={mode} />
											</LoadOnScreen>
										</div>
									</Col>
								)}
						</>
					)}

					{/* Content */}
					<Col span={24} className="pd-main-content">
						<Row>
							<Col
								span={24}
								lg={17}
								className="pd-main-content-left padding-reverse-extra">
								<Col span={24} className="pd-main-top">
									<OnScreen
										onEnterView={() => {
											setShowAffix(false);
										}}
										onLeaveView={() => {
											setShowAffix(true);
										}}>
										{/* Property Cover */}
										<Col
											span={24}
											className="pd-property-cover-col padding-reverse-extra">
											<div className="container pd-container">
												<PropertyCover
													isDisabledProperty={!listing.active}
													tour3d={listing.tour3d}
													images={listing.images}
													img={listing.img}
													isProject={listing.isProject}
													mode={mode}
													id={listing.id}
													onTabClick={tab => {
														setModalTabOpen(tab);
														setModalOpen(true);
													}}
													loading={loading}
													files={listing.files}
													youtube={
														listing.isProject
															? listing.video
															: listing.youtube
													}
													latitude={listing.latitude}
												/>
											</div>
										</Col>

										<Col
											span={24}
											className="pd-main-content-info padding-other">
											<div className="container">
												<Row
													gutter={[
														{
															sm: theme.spacing.smSpacing,
															xs: theme.spacing.smSpacing,
															lg: theme.spacing.mdSpacing,
														},
														theme.spacing.lgSpacing,
													]}>
													<Col span={24} sm={14} lg={14}>
														{/* Title */}
														<Title
															title={listing.title}
															limitLength={2}
															hideInformation={false}
															loading={loading}
														/>
														{/* Typology Tag Desktop */}
														<TypologyTag
															propertyType={propertyTypeId}
															operationType={operationTypeId}
															bedrooms={listing.bedrooms}
															rooms={listing.rooms}
															bathrooms={listing.bathrooms}
															m2={
																listing.minM2 > 0
																	? listing.minM2
																	: listing.m2
															}
															guests={listing.guests}
															loading={loading}
															className="property-typology-tag-desktop"
															showIcons
														/>
													</Col>

													{/* Price Tag */}
													{!isTemporal(operationTypeId) &&
														listing.price ? (
														<Col span={14} sm={10} lg={10}>
															<PriceTag
																showOperationType={true}
																shortExpensesText={false}
																mode={mode}
																price={listing.price}
																priceVariation={
																	listing.price_variation
																}
																commonExpenses={
																	listing.commonExpenses
																}
																temporalCurrency={
																	listing.temporal_currency
																}
																temporalPrice={
																	listing.temporal_price
																}
																operationType={
																	listing.operation_type
																}
																isProject={listing.isProject}
																loading={loading}
															/>
														</Col>
													) : null}

													{/* Typology Tag Mobile */}
													<Col span={10} sm={24} lg={24}>
														<TypologyTag
															className="property-typology-tag-mobile"
															propertyType={propertyTypeId}
															operationType={
																listing.operation_type?.id
															}
															bedrooms={listing.bedrooms}
															rooms={listing.rooms}
															bathrooms={listing.bathrooms}
															m2={
																listing.minM2 > 0
																	? listing.minM2
																	: listing.m2
															}
															hectares={listing.hectares}
															guests={listing.guests}
															loading={loading}
															showIcons
														/>
													</Col>

													{/* Property Local Information */}
													<Col span={24}>
														<PropertyLocalInformationMap
															isProject={listing.isProject}
															latitude={listing.latitude}
															longitude={listing.longitude}
															pointType={listing?.pointType}
															onStreetViewClick={() => {
																setModalTabOpen("streetView");
																setModalOpen(true);
															}}
															onMapClick={() => {
																setModalTabOpen("map");
																setModalOpen(true);
															}}
															id={listing.id}
															propId={id} // Envio el Id de la prop que recibe el componente, cuando es proyecto se pierde el Id al hacer spread en los hook.
															mode={mode}
															seaDistance={listing.seaDistanceName}
														/>
													</Col>
												</Row>
											</div>
										</Col>
									</OnScreen>
								</Col>

								{screen.xs && (
									<OnScreen
										onEnterView={() => setShowAffixBottom(false)}
										onLeaveView={() => setShowAffixBottom(true)}>
										<Col span={24} className="padding">
											<div className="container">
												{/* Financiación Card*/}
												<Financing
													id={listing.id}
													reference={listing.code}
													isDisabledProperty={!listing.active}
													operationType={operationTypeId}
													propertyType={propertyTypeId}
													propertyPrice={listing.price}
													showFinancingCard={true}
													financingRef={financingRef}
												/>
												<InformationRequest
													id={listing.id}
													identifier={2}
													mode={mode}
													disabled={!listing.active}
													showCTA
													owner={listing.owner}
													queryRouter={queryRouter}
												/>
											</div>
										</Col>
									</OnScreen>
								)}

								{mode === "property" && (
									<Col span={24} className="padding">
										<div className="container">
											<Typography.Title level={4}>
												{"Detalles de la Propiedad"}
											</Typography.Title>
											<TechnicalSheet
												isDisabledProperty={!listing.active}
												mode={mode}
												id={listing.id}
												technicalSheets={technicalSheet}
												loading={loading}
											/>
										</div>
									</Col>
								)}

								{/* Infomación del proyecto */}
								{mode === "project" && (
									<Col span={24} className="padding">
										<div className="container">
											<Typography.Title level={4}>
												{"Información del proyecto"}
											</Typography.Title>
											<ProjectInfo
												projectId={id}
												loading={loading}
												percentageFinished={listing.percentage_finished}
												percentageSold={listing.percentage_sold}
												ocupation={listing.ocupation}
												builder={listing.builder}
												finalization={listing.finalization}
												constructionState={listing.constructionState?.name}
											/>
										</div>
									</Col>
								)}

								{/* Ambientes && Amenities */}
								<Col span={24} className="padding">
									<div className="container">
										<Facilities
											mode={mode}
											facilities={listing.facilities}
											loading={loading}
										/>
									</div>
								</Col>

								{/* Description */}
								{(listing.description || mode === "project") && (
									<Col span={24} className="padding description-container">
										<div className="container">
											<Description
												description={listing.description}
												loading={loading}
												hideInformation={false}
												showTitle={true}
												keepFormat
											/>
										</div>
									</Col>
								)}

								<div className="container padding">
									<Guarantee
										guarantee={listing.guarantee}
										opTypeID={listing.operation_type?.id}
									/>
								</div>

								{/* Financiación*/}
								<Col span={24} className="padding" ref={financingRef}>
									<div className="container">
										<Financing
											id={listing.id}
											reference={listing.code}
											isDisabledProperty={!listing.active}
											operationType={operationTypeId}
											propertyType={propertyTypeId}
											propertyPrice={listing.price}
										/>
									</div>
								</Col>

								{/* Unidades */}
								{mode === "project" && listing.commercial_units?.length && (
									<Col span={24} className="padding">
										<div className="container">
											<Typography.Title level={4}>
												{"Unidades"}
											</Typography.Title>
											<Units
												comertialUnits={listing.commercial_units}
												loading={loading}
											/>
										</div>
									</Col>
								)}

								{/* Avances de obra */}
								{mode === "project" && (
									<Col span={24} className="padding">
										<div className="container">
											<WorkProgress
												images={listing.images}
												loading={loading}
											/>
										</div>
									</Col>
								)}

								{/* Big Data Single Prop */}
								{ !ocultarBigDataFicha_aPedidoHardcodeado(listing.id) && mode !== "project" && !isTemporal(operationTypeId) && (
									<Col span={24} className="padding">
										<div className="container">
											<BigDataSingleProp id={listing.id} />
										</div>
									</Col>
								)}


								{/* OfficeHours */}
								{mode === "project" && country_code !== "BR" && (
									<Col span={24} className="padding-extra">
										<div className="container">
											<Typography.Title level={4}>
												{"Horario de oficina"}
											</Typography.Title>
											<OfficeHours owner={listing.owner} />
										</div>
									</Col>
								)}
							</Col>

							<Col
								span={0}
								lg={7}
								className="pd-main-content-right padding-reverse-extra">
								{country_code !== "BR" && (
									<Col span={24}>
										{/* Financiación Card*/}
										<div className="container">
											<Financing
												id={listing.id}
												reference={listing.code}
												isDisabledProperty={!listing.active}
												operationType={operationTypeId}
												propertyType={propertyTypeId}
												propertyPrice={listing.price}
												showFinancingCard={true}
												financingRef={financingRef}
											/>
										</div>
									</Col>
								)}
								<Col
									span={24}
									id={"myForm"}
									className="col-information-request-small-left">
									<div className="container">
										{/* Information Request*/}
										<InformationRequest
											id={listing.id}
											identifier={2}
											mode={mode}
											disabled={!listing.active}
											showCTA
											owner={listing.owner}
											queryRouter={queryRouter}
										/>
									</div>
								</Col>
							</Col>
						</Row>
					</Col>

					{/* Calendar */}
					{isTemporal(operationTypeId) ? (
						<div className="container padding">
							<Typography.Title level={4}>
								{"Calendario de disponibilidad"}
							</Typography.Title>
							<AvailabilityCalendar id={listing.id} />
						</div>
					) : null}

					{/* Temporary Rental */}
					{isTemporal(operationTypeId) ? (
						<div className="container padding">
							<Typography.Title level={4}>{"Alquiler Temporal"}</Typography.Title>
							<TemporaryRental id={listing.id} />
						</div>
					) : null}

					{/* Property Similars */}
					{((listing.isProject && listing.commercial_units.length > 0) ||
						!listing.isProject) && (
							<Col id="mySimilar" span={24} className="property-similar-col padding">
								<div className="container">
									<LoadOnScreen listen={!loading}>
										<PropertySimilars
											id={listing.id}
											mode={mode}
											isTemporal={isTemporal(operationTypeId)}
											show={listing.price?.amount > 0}
										/>
									</LoadOnScreen>
								</div>
							</Col>
						)}

					{/* Sub Sidiaries && Information Request */}
					{country_code !== "BR" && (
						<div className="container pd-ir-container-big padding">
							<OnScreen
								onEnterView={() => setShowAffixBottom(false)}
								onLeaveView={() => setShowAffixBottom(true)}>
								<InformationRequest
									id={listing.id}
									identifier={3}
									mode={mode}
									owner={listing.owner}
									disabled={!listing.active}
									inmoPropsLink={listing.owner ? listing.owner.inmoPropsLink : undefined}
								>
									<Subsidiaries
										id={listing.id}
										listing={listing}
										mode={mode}
										owner={listing.owner}
										loading={loading}
										seller={listing.seller}
										disabled={!listing.active}
									/>
								</InformationRequest>
							</OnScreen>
						</div>
					)}

					{/* Seo Text */}
					<div className="container padding">
						<SeoText />
					</div>

					{/* Seo Text BreadCrumbs */}
					<div className="container padding">
						<Text>
							<BreadCrumbs />
						</Text>
					</div>

					{/* Footer */}
					<div className="container padding">
						<Footer />
					</div>
				</div>

				{/* Footer Image */}
				<PicHomeFooter />

				{/* show Affix Bottom && Property Affix Bottom */}
				{listing.active && showAffixBottom && !screen.lg && (
					<PropertyAffixBottom id={listing.id} mode={mode} />
				)}
			</div>
			<style jsx global>{`
				.property-detail .pd-main-content-right .sticky {
					top: ${top}px;
					position: -webkit-sticky;
					position: sticky;
					transition: all 0.5s ease 0s;
				}
			`}</style>
		</div>
	</>);
}

